import { Headline1, P } from '@/app/components/Typography'
import { Header } from '@/app/modules/shared/components/Header'
import Head from 'next/head'

import { Footer } from '@/app/components/Footer'
import { PropsWithChildren } from 'react'
import resolveConfig from 'tailwindcss/resolveConfig'
import myConfig from '../../../../../../tailwind.config'

type ErrorPageWithImageProps = PropsWithChildren<
  {
    title: string
    pageTitle: string
    description: string
    mobileImage: string
    desktopImage: string
    alt: string
  } & React.HTMLAttributes<HTMLDivElement>
>

export function ErrorPageWithImage({
  title,
  pageTitle,
  description,
  mobileImage,
  desktopImage,
  alt,
  children,
  ...props
}: ErrorPageWithImageProps) {
  const { theme } = resolveConfig(myConfig)

  return (
    <>
      <Head>
        <title>{`${pageTitle} | Mydra`}</title>
      </Head>
      <Header />
      <main
        {...props}
        className={`flex min-h-screen w-full flex-col overflow-x-clip ${props.className}`}
      >
        <div className="container grid grid-cols-4 gap-y-6 py-4 md:grid-cols-12">
          <picture className="col-span-full row-start-1 md:col-span-4 md:col-start-7 md:col-end-12 lg:col-start-8">
            <source
              srcSet={desktopImage}
              media={`(min-width: ${theme.screens.md})`}
            />
            <img src={mobileImage} alt={alt} />
          </picture>
          <div className="col-span-full row-start-2 flex flex-col gap-5 md:col-span-5 md:col-end-5 md:row-start-1 md:gap-6 md:pt-20">
            <Headline1>{title}</Headline1>
            <P className="text-[--text]">{description}</P>
            {children && <div className="mt-3 md:mt-10">{children}</div>}
          </div>
        </div>
        <Footer className="mt-auto w-full" />
      </main>
    </>
  )
}
